function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs6"
});

var SvgModularLogo = function SvgModularLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 702.96002 173.96001",
    height: 173.96001,
    width: 702.96002,
    id: "svg2",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,173.96)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fill: "#fffdfe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 1847.47,642.371 1737.51,446.043 H 1627.59 L 1517.62,642.371 V 336.09 h -141.35 v 549.726 h 149.19 l 157.07,-290.554 157.08,290.554 h 149.22 V 336.09 h -141.36 v 306.281"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "#fffdfe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3859.52,446.043 h 286.65 V 336.09 h -427.99 v 549.738 h 141.34 V 446.043"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    style: {
      fill: "#fffdfe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4319.46,336.09 h -153.11 l 208.09,549.738 h 157.08 l 208.1,-549.738 h -153.15 l -35.31,98.164 H 4354.8 Z m 70.69,200.265 h 125.68 L 4453,720.914 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "#fffdfe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4215.34,225.309 c 0,-11.071 5.57,-16.59 16.65,-16.579 l 49.84,0.122 c 18.12,0.027 31.42,-4.122 39.91,-12.454 8.5,-8.328 12.8,-21.386 12.85,-39.199 l 0.03,-13.629 c 0.03,-17.8 -4.19,-30.898 -12.65,-39.281 -8.48,-8.3593 -21.77,-12.5702 -39.86,-12.5976 -5.54,-0.0117 -11.42,-0.0312 -17.59,-0.0508 -6.19,-0.0117 -12.47,-0.0312 -18.83,-0.039 -6.38,-0.0235 -12.75,-0.0235 -19.12,-0.043 -6.36,-0.0391 -12.4,-0.0469 -18.13,-0.0469 -13.5,-0.0312 -26.86,1.1172 -40.15,3.5078 l -0.1,35.4605 c 13.48,0.032 26.58,0.051 39.31,0.079 10.91,0.019 22.17,0.05 33.81,0.082 11.62,0.019 21.52,0.031 29.64,0.07 4.21,0.008 7.61,1.187 10.09,3.559 2.47,2.351 3.71,5.511 3.71,9.531 l -0.04,23.488 -63.7,-0.141 c -19.38,-0.027 -33.5,4.313 -42.28,13.051 -8.79,8.762 -13.21,22.832 -13.24,42.242 l -0.04,8.309 c -0.03,19.359 4.32,33.469 13.04,42.262 8.76,8.777 22.85,13.199 42.24,13.25 l 97.2,0.226 0.1,-38.789 -86.14,-0.199 c -11.06,-0.012 -16.58,-5.578 -16.58,-16.648 l 0.03,-5.543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "#fffdfe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4333.65,286.52 52.62,0.109 45.91,-94.039 45.5,94.262 52.6,0.109 -73.07,-142.801 0.14,-51.2381 -49.85,-0.1211 -0.12,51.2302 -73.73,142.489"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    style: {
      fill: "#fffdfe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4580.57,226.148 c 0.03,-11.089 5.59,-16.609 16.66,-16.578 l 49.87,0.121 c 18.09,0.028 31.38,-4.121 39.89,-12.453 8.49,-8.347 12.78,-21.386 12.84,-39.218 l 0.03,-13.61 c 0.03,-17.789 -4.18,-30.898 -12.66,-39.281 -8.46,-8.3595 -21.76,-12.5704 -39.84,-12.6095 -5.56,0 -11.39,-0.0195 -17.61,-0.039 -6.19,-0.0117 -12.44,-0.0313 -18.82,-0.0391 -6.36,-0.0195 -12.75,-0.043 -19.13,-0.043 -6.34,-0.0078 -12.4,-0.039 -18.1,-0.039 -13.5,-0.0391 -26.89,1.1289 -40.18,3.5 l -0.1,35.4606 c 13.49,0.032 26.59,0.051 39.35,0.078 10.89,0.024 22.15,0.051 33.78,0.082 11.65,0.02 21.52,0.059 29.65,0.079 4.24,0 7.6,1.179 10.08,3.531 2.5,2.371 3.74,5.551 3.74,9.551 l -0.05,23.5 -63.72,-0.153 c -19.39,-0.027 -33.51,4.313 -42.26,13.071 -8.79,8.742 -13.22,22.812 -13.25,42.222 l -0.04,8.289 c -0.04,19.379 4.31,33.481 13.07,42.282 8.75,8.777 22.82,13.218 42.19,13.25 l 97.21,0.207 0.11,-38.77 -86.15,-0.18 c -11.07,-0.031 -16.59,-5.589 -16.59,-16.66 l 0.03,-5.551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fill: "#fffdfe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4811.1,93.7383 -49.87,-0.1367 -0.35,155.1364 -58.16,-0.148 -0.09,38.769 166.18,0.379 0.1,-38.769 -58.16,-0.129 0.35,-155.1017"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    style: {
      fill: "#fffdfe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5038.8,94.2617 -153.72,-0.3711 -0.44,193.8984 153.72,0.352 0.09,-38.789 -103.87,-0.231 0.09,-37.391 81.7,0.192 0.09,-38.793 -81.69,-0.188 0.06,-40.152 103.88,0.231 0.09,-38.7583"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    style: {
      fill: "#fffdfe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5221.8,202.699 -38.61,-69.359 -38.8,-0.07 -38.93,69.16 0.25,-108.0081 -49.87,-0.1328 -0.44,193.8829 52.63,0.129 55.66,-102.352 55.13,102.602 52.63,0.129 0.45,-193.8792 -49.83,-0.1289 -0.27,108.0271"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    style: {
      fill: "#fffdfe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2235.18,438.191 c -31.42,0 -47.13,15.692 -47.13,47.129 v 251.293 c 0,31.407 15.71,47.129 47.13,47.129 h 43.02 v 109.942 h -74.44 c -54.97,0 -94.92,-12.442 -119.76,-37.309 -24.87,-24.883 -37.31,-64.781 -37.31,-119.762 V 485.32 c 0,-54.98 12.44,-94.914 37.31,-119.765 24.84,-24.875 64.79,-37.317 119.76,-37.317 h 74.44 v 109.953 h -43.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    style: {
      fill: "#fffdfe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 2519.85,856.363 C 2495,881.238 2455.06,893.68 2400.1,893.68 h -74.47 V 783.746 h 43.04 c 31.43,0 47.14,-15.723 47.14,-47.129 V 485.328 c 0,-31.453 -15.71,-47.137 -47.14,-47.137 h -43.04 V 328.238 h 74.47 c 54.96,0 94.9,12.442 119.75,37.317 24.86,24.851 37.29,64.785 37.29,119.773 v 251.289 c 0,54.981 -12.43,94.879 -37.29,119.746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    style: {
      fill: "#fffdfe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2756.39,446.043 h 0.05 v 329.832 h -0.05 V 446.043"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    style: {
      fill: "#fffdfe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3055.97,839.887 c -30.61,30.629 -75.51,45.941 -134.68,45.941 H 2803.82 V 775.875 h 86.07 c 47.15,0 70.68,-23.559 70.68,-70.691 V 516.715 c 0,-47.11 -23.53,-70.672 -70.68,-70.672 h -86.07 V 336.09 h 117.47 c 59.17,0 104.07,15.312 134.68,45.949 30.66,30.625 45.94,75.527 45.94,134.676 v 188.469 c 0,59.179 -15.28,104.07 -45.94,134.703"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    style: {
      fill: "#fffdfe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2756.39,446.043 v 329.832 h 0.03 v 109.953 h -141.4 V 336.09 h 141.4 v 109.953 h -0.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    style: {
      fill: "#fffdfe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 3510.75,885.828 V 485.32 c 0,-31.437 -15.71,-47.129 -47.11,-47.129 h -35.2 V 328.25 h 66.6 c 54.98,0 94.9,12.422 119.77,37.305 24.87,24.863 37.3,64.785 37.3,119.765 v 400.508 h -141.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    style: {
      fill: "#fffdfe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3345.83,438.191 c -31.41,0 -47.11,15.692 -47.11,47.129 V 885.824 H 3157.37 V 485.32 c 0,-54.98 12.44,-94.914 37.3,-119.765 24.86,-24.875 64.8,-37.317 119.75,-37.317 h 66.59 v 109.953 h -35.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    style: {
      fill: "#fffdfe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4777.41,336.102 h 140.9 v 549.726 h -140.9 V 336.102"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    style: {
      fill: "#fffdfe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5173.99,508.863 c 31.42,7.844 54.33,23.828 68.72,47.903 14.37,24.082 21.57,57.851 21.57,101.308 v 70.688 c 0,54.98 -12.43,94.879 -37.28,119.769 -24.9,24.86 -64.78,37.293 -119.76,37.293 H 4965.7 V 775.871 h 110.13 c 31.41,0 47.11,-15.699 47.11,-47.109 v -70.688 c 0,-31.406 -15.7,-47.109 -47.11,-47.109 H 4965.7 V 501.012 h 63.02 l 90.29,-164.922 h 153.14 l -98.16,172.773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    style: {
      fill: "#fffdfe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 1207.71,1304.7 485.543,1079.91 V 990.129 L 0,870.035 V 358.699 L 914.391,0 v 1043.92 l 258.419,-6.82 V 49.9492 L 2276.62,187.898 v 35.903 l -1044.86,-111.012 0.2,922.961 1046.34,-24.63 v 132.85 z m -686.659,-306.501 -0.129,52.811 c 51.359,14.49 651.888,189.79 651.888,189.79 0,0 -0.1,-127.06 0,-151.61 l -281.83,13.36 z m 334.398,41.421 V 91.0195 L 35.3633,384.43 v 454.84 z m 1399.281,84.65 v -87.9 l -1022.53,50.59 v 157.62 c 10.28,-1.27 1022.53,-120.31 1022.53,-120.31"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgModularLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MODULAR_logo.778ea7b5.svg";
export { ForwardRef as ReactComponent };